import type { TFunction } from 'i18next';
import { Crop, CropApi, Field } from '../types';

export const getCropColorById = (id: string | null | undefined, crops: CropApi[] | null | undefined): string => {
  if (!id || !crops) {
    return 'transparent';
  }

  return crops.filter((c) => c.id === id)[0]?.color || 'transparent';
};

export const getCropName = ({ t, id }: { t: TFunction; id: string | null | undefined }): string => {
  if (!id) return t('empty.noData');
  const translatedName = t ? t(`crops.${id}`) : null;
  return translatedName ? translatedName : id.replace(/_/g, ' ');
};

export const getWorkspaceCrops = ({ fields, crops }: { fields: Field[] | null; crops: CropApi[] | null }): Crop[] => {
  const cropsList: Crop[] = [];
  if (fields && fields.length) {
    fields.forEach((field) => {
      if (field.seasons && field.seasons.length) {
        field.seasons.forEach((season) => {
          if (season.cropId && !cropsList.find((crop) => crop.id === season.cropId)) {
            cropsList.push({
              id: season.cropId,
              color: getCropColorById(season.cropId, crops),
            });
          }
        });
      }
    });
  }
  return cropsList;
};
